const quickBookBarSticky = function () {
  const header = document.querySelector(".voyager-header");
  const quickBookAlignWith = header?.querySelector(
    ".voyager-header__title-wrapper"
  );
  const quickBookBar = document.querySelector(".voyager-booking");

  if (!quickBookBar || !header || !quickBookAlignWith) return false;

  const quickBookBarDefaultTop = quickBookBar.offsetTop;
  const hero = document.querySelector(".voyager-hero");
  const heroGallery = document.querySelector(".voyager-hero-gallery");
  const getTopSpacing = () => {
    if (hero) return 30;
    if (heroGallery) return 30;

    return 0;
  };

  let lastScrollTop = 0;

  document.addEventListener("scroll", () => {
    if (window.scrollY === lastScrollTop) return;

    if (window.scrollY + getTopSpacing() >= quickBookBar.offsetTop) {
      document.body.classList.add("body--booking-panel-pinned");
    }

    if (window.scrollY + getTopSpacing() < quickBookBarDefaultTop) {
      document.body.classList.remove("body--booking-panel-pinned");
    }

    lastScrollTop = window.scrollY;
  });
};

quickBookBarSticky();
